"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
/**
 * Custom validation error messages map
 */
const customErrorsMap = {
    password: {
        'schema/pattern': {
            text: values => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/UpdatePasswordForm/Password/ErrorMessage/WrongFormat:text', defaultMessage: 'Password should contain latin letters and digits.', values: values })),
        },
        'schema/minLength': {
            text: values => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/UpdatePasswordForm/Password/ErrorMessage/MinLength:text', defaultMessage: 'Password should contain at least{limit, plural,\r\n                    one {# character}\r\n                    other {# characters}\r\n                    }.', values: values })),
        },
    },
    passwordConfirm: {
        'schema/repeated': {
            text: values => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/UpdatePasswordForm/PasswordConfirm/ErrorMessage/DoesNotMatch:text', defaultMessage: 'Passwords does not match.', values: values })),
        },
    },
};
exports.default = customErrorsMap;
//# sourceMappingURL=customErrorsMap.js.map